import styled from 'styled-components';

const ScrollAnchorElement = styled.div`
  position: absolute;
  top: -5rem;
`;

export default ScrollAnchorElement;
